/* const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');

addToCartForms.forEach((form) => {
  form.addEventListener("submit", async (event) => {
    // Prevent normal submission
    event.preventDefault();

    // Submit form with ajax
    await fetch("/cart/add", {
      method: "post",
      body: new FormData(form),
    });

    // Get new cart object
    const res = await fetch("/cart.json");
    const cart = await res.json();

    // Update cart count
    document.querySelectorAll(".cart-count").forEach((el) => {
      el.textContent = cart.item_count;
    });

    // Display message
    const message = document.createElement("p");
    message.classList.add("added-to-cart");
    message.textContent = "Added to cart!";
    form.appendChild(message);
  });
}); */


/* WORKING */
const FreeProduct1 = '9062435455284';

/* $(document).ready(function() {
  // Listen for the add to cart event
  $('form[action="/cart/add"]').submit(function(event) {
    event.preventDefault();
    
    // Check if the added item has a selling_plan parameter
    var formData = $(this).serialize();
    var sellingPlanParam = formData.match(/(?:^|&)selling_plan=(.*?)(?:&|$)/);

    if (sellingPlanParam) {
      // Make AJAX request to add the item to the cart
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: formData,
        dataType: 'json',
        success: function(data) {
          // Optionally, you can do something after the item is successfully added to the cart
          console.log('Item added to cart:', data);
          addFreeProduct1();
        },
        error: function(xhr, status, error) {
          console.error('Error adding item to cart:', status, error);
        }
      });
    }
  });
});

function addFreeProduct1() {
  console.log("Added Free Product")
} */



/* $(document).ready(function() {
    // Event listener for click event anywhere in the window
    $(document).on('click', function() {
        // Call a function to add the item to the cart
        addItemToCart();
    });

    // Function to add item to the cart
    function addItemToCart() {
        // Replace these values with your actual product variant ID and quantity
        var productId = FreeProduct1;
        var quantity = 1; // Adjust quantity as needed

        // Shopify AJAX API to add item to the cart
        jQuery.post('/cart.js', {
            quantity: quantity,
            id: productId
        })
        .done(function() {
            // Alert or any other action after successfully adding item to cart
            console.log('Item added to cart:', productId);
            console.log(cart)
        })
        .fail(function(xhr, textStatus, errorThrown) {
            // Error handling if adding item to cart fails
            console.error('Error adding item to cart:', errorThrown);
        });
    }
}); */

// Function to fetch cart data
/* function fetchCartData() {
    var url = '/cart.js';
    fetch(url, { method: 'GET' })
        .then(res => res.json())
        .then(response => {
            // console.log('Success:', JSON.stringify(response));
            const cart = response;
            // We now have access to Shopify cart object
             console.log(cart);
            // Store cart items array
        })
        .catch(error => console.error('Error:', error));
}

// Event listener for click event anywhere in the window
window.addEventListener('click', function() {
    // Call the function to fetch cart data
    fetchCartData();
}); */






